import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';

const DuplicateHandle = {
  name:   'duplicateHandle',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const translateX =  (moveable.props.cropHandle) ? 41 : 0;
    const rect       = moveable.getRect();
    const { pos2 }   = moveable.state;
    return React.createElement('div', {
      class: 'extended-button duplicate-button d-flex align-items-center justify-content-center mt-5"',
      style: {
        position:        'absolute',
        left:            '0px',
        top:             '0px',
        transform:       `translate(${pos2[0]}px, ${pos2[1]}px) rotate(${rect.rotation}deg) translate(10px, ${translateX}px)`,
        transformOrigin: '0 0',
      },
      key:     'duplicate-handle',
      onClick: (event) => {
        event.stopPropagation();
        EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.OBJECT_DUPLICATE, { name: 'extrabuttondublication', call: 'call from onMoveableDirectionClick function' });
      },
    }, '');
  },
};
export default DuplicateHandle;
